import styled from 'styled-components';
import { Card as ToolkitCard } from '@mlc/web-ui-toolkit';

export const Card = styled(ToolkitCard)`
	min-height: 250px;
`;
